<template>
  <v-container>
    <p>Event Date: {{formattedEventDate}}</p>
    <p>Event Time: Doors: {{formattedDoorsTime}} Show: {{formattedEventTime}} Ideally, contestants should arrive by {{formattedArrivalTime}}</p>
    <h3>Theme: {{ theme }}</h3>
    <p> Registration Deadline: {{formattedRegistrationEnd}} </p>
    <h3>Entry Fee:   Solo  Duet   {{entryFee}}</h3>
    <p> All Entry Fees must be received by {{formattedEntryFeePaid}} </p>
    <h1 class="highlight"> Prize: <span class="blink"> {{prizeAmount}} </span>  Prize to the winner</h1>
    <p> The remainder of the proceeds will be donated to {{charityBenefactor}}</p>
    <p> Registration: registration will begin on <b>{{formattedRegistrationStart}}</b> and run until <b>{{formattedRegistrationEnd}}</b>.</p>
    <h2 class="underlined"> Only 10 Spots are Available</h2>
    <ol class="pt-7" ><h3 class="underlined">Rules</h3>
      <li> Each constant must perform a song of the appropriate theme no longer than 5 minutes in length. Performances can be "live" vocals or lip-sync. If your music goes over the 5-minute allotted time, the DJ will cut your music, and 10 points will be deducted from your score.</li>
      <li> Contestants must be registered <b>by 11:59 PM {{formattedRegistrationEnd}} </b>; we will not accept any registrations after this time. </li>
      <li> The entry fee of {{entryFee}} will need to be paid before <b>11:59 PM on {{formattedEntryFeePaid}}.</b> </li>
      <li> <b>All contestants arrive at Club Cafe by {{formattedArrivalTime}} </b></li>
      <li> Contestants are required to advertise this event. Each contestant will receive a custom code to track ticket sales, and whoever sells the most tickets will receive an award for their efforts.</li>
      <li> Music <b>MUST</b> be sent to battleroyaleboston@gmail.com by <b> {{formattedMusicDeadline}} </b> </li>
    </ol>
    <ol class="pt-7"> <h3 class="underlined"> Judging </h3> <p> Contestants will be judged on the following: </p>
      <li>Stage presence (Do you command the stage and you have the audience's attention) 10pts per judge</li>
      <li>Vocals quality or lip sync 10 pts per judge ( You are not being judged on both. it will be one or the other for the same point value)</li>
      <ul class="sublist"> Breakdown:
          <li> Vocals: How is your tone, and pitch? Were you off-key?</li>
          <li> Lip Sync: Do your lips match the words for the track you are performing to?</li>
      </ul>
      <li>The entry fee of {{entryFee}} duet will need to be paid before 11:59 PM on {{formattedEntryFeePaid}}.</li>
      <li>Overall concept: The judges are looking for your ability to convey the message set forth by your song. Does your choice of costuming fit your message? 10 pts per judge </li>
      <li>Did you adhere to the allotted 5-minute time frame? (this will be a yes or no question. If the answer is "NO",  10 pts total will be deducted.) (no added point value) </li>
    </ol>
    <h1 class="highlight"> The Entry Fee is <span class="blink">Non-refundable</span> </h1>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="4">
        <ColorButton :url="registrationLink" text="Register"></ColorButton>
      </v-col>
      <v-spacer></v-spacer>

    </v-row>
  </v-container>
</template>

<style scoped>

</style>

<script>
import ColorButton from '@/components/ColorButton'
import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState([
        'registrationLink',
        'registrationStart',
        'registrationEnd',
        'entryFeePaid',
        'eventDate',
        'eventTime',
        'doorsTime',
        'entryFee',
        'charityBenefactor',
        'arrivalTime',
        'musicDeadLine',
        'prizeAmount',
        'theme'
      ]),
      // Formatted dates
      formattedEventDate() {
        return this.formatDate(this.eventDate)
      },
      formattedRegistrationStart() {
        return this.formatDate(this.registrationStart)
      },
      formattedRegistrationEnd() {
        return this.formatDate(this.registrationEnd)
      },
      formattedEntryFeePaid() {
        return this.formatDate(this.entryFeePaid)
      },
      formattedMusicDeadline() {
        return this.formatDate(this.musicDeadLine)
      },
      // Formatted times
      formattedDoorsTime() {
        return this.formatTime(this.doorsTime)
      },
      formattedEventTime() {
        return this.formatTime(this.eventTime)
      },
      formattedArrivalTime() {
        return this.formatTime(this.arrivalTime)
      }
    },
    methods: {
      formatDate(date) {
        if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return date || ''
        const [year, month, day] = date.split('-')
        const months = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December']
        const dayNum = parseInt(day, 10)
        const suffix = ['th', 'st', 'nd', 'rd'][(dayNum % 10 > 3 || Math.floor(dayNum % 100 / 10) === 1) ? 0 : dayNum % 10]
        return `${months[parseInt(month, 10) - 1]} ${dayNum}${suffix}, ${year}`
      },
      formatTime(time) {
        if (!time || !/^\d{2}:\d{2}$/.test(time)) return time || ''
        const [hours, minutes] = time.split(':')
        const hour = parseInt(hours, 10)
        const ampm = hour >= 12 ? 'PM' : 'AM'
        const hour12 = hour % 12 || 12
        return `${hour12}:${minutes} ${ampm}`
      }
    },
    components: {
      ColorButton,
    },

  };
</script>

<style scoped>
p, ul, li, h2, ol, h1, h3 {
  color: white;
  font-family: 'BaskervilleMTW01-SmBdIt';
}

li {
  margin-left: 5%;
  padding: 10px;
}
.sublist {
  margin-left: 5%;
}



.blink {
  animation: blinker 1.7s step-start infinite;
}

@keyframes blinker {
    50% {
    color: #CC48CE;
  }
}

.highlight {
  color: #ffdd00;
}


.underlined {
  text-decoration: underline;
}
</style>


